import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a64fa1b6&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=a64fa1b6&prod&lang=less&scoped=true&"
import style1 from "./index.vue?vue&type=style&index=1&id=a64fa1b6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@https+++registry.npmmirror.com+vue-loader+-+vue-loader-15.10.2.tgz_cache-loader@4._xbc2zsunuyw4mnfmppd25q2opq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a64fa1b6",
  null
  
)

export default component.exports